import React from "react";
import { Navbar, Footer, } from "../../components/shared";
import useCheckLoggedin from "../../utils/useCheckLoggedin";
import { Helmet } from "react-helmet-async";
import '../general/General.css';

import MessagesDetails from "./Messages";
import { Breadcrumbs } from '../../components/shared';

const UserInbox = () => {
  useCheckLoggedin(); // Check if the user is logged in (if no user data, redirect to login)
  return (
    <>
      <Helmet>
        <title>உங்கள் செய்திகள்</title>
        <link rel="canonical" href="/user/profile" />
      </Helmet>
      <Navbar />



      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <Breadcrumbs /><br />

            <div className="detail-card">
              <MessagesDetails />
            </div>

          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default UserInbox;
